import { ButtonSolid, ButtonGhost } from 'ui/components/primitives';
import { Footer } from './Modal.components.styles';
import { Variant } from './Modal.components.enums';
import type { FooterProps } from './Modal.components.d';

const FooterBase = ({
  cancelAction,
  cancelLabel,
  primaryAction,
  primaryLabel,
  secondaryAction,
  secondaryLabel,
  variant,
}: FooterProps) => (
  <Footer>
    {cancelLabel && variant !== Variant.INFORMATION && (
      <ButtonGhost onClick={cancelAction}>{cancelLabel}</ButtonGhost>
    )}
    {secondaryLabel && variant !== Variant.INFORMATION && (
      <ButtonGhost onClick={secondaryAction}>{secondaryLabel}</ButtonGhost>
    )}
    <ButtonSolid
      onClick={primaryAction}
      variant={variant === Variant.DESTRUCTIVE ? 'warning' : undefined}
    >
      {primaryLabel}
    </ButtonSolid>
  </Footer>
);

export default FooterBase;
